<template>
<div class="st-page">
  <Navigation />
  <div class="container" style="padding-top:20px;">
    <div class="d-flex align-items-center justify-content-between mb-4">
      <div class="d-flex align-items-center gap-3">
        <a href="javascript:void(0)" @click="$router.push('/dashboard')" class="st-back"><i class="mdi mdi-arrow-left"></i></a>
        <div><h4 class="st-page-title"><i class="mdi mdi-file-document me-2"></i>Fee Statement</h4></div>
      </div>
      <div class="d-flex gap-2">
        
      </div>
    </div>

    <div v-if="loading" class="st-spinner"><div class="spinner-border"></div></div>
    <div v-else>
      <div class="st-card">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="st-search-wrap"><i class="mdi mdi-magnify"></i><input class="st-search" v-model="search" placeholder="Search..." @input="onSearch" /></div>
          <span style="color:#8BA4C4;font-size:13px;">{{ items.length }} records</span>
        </div>
        <div style="overflow-x:auto;" v-if="items.length">
          <table class="st-table">
            <thead><tr><th>Term</th><th>Total</th><th>Paid</th><th>Outstanding</th><th>Scholarship</th><th>Actions</th></tr></thead>
            <tbody>
              <tr v-for="item in filteredItems" :key="item.id">
                <td>{{ item.term_name || '-' }}</td>
                <td>KSh {{ fNum(item.total_fees) }}</td>
                <td>KSh {{ fNum(item.total_paid) }}</td>
                <td>KSh {{ fNum(item.outstanding) }}</td>
                <td>KSh {{ fNum(item.scholarship_amount) }}</td>
                <td><button class="st-btn st-btn-sm st-btn-blue" @click="viewItem(item)"><i class="mdi mdi-eye"></i></button></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="st-empty"><i class="mdi mdi-file-document"></i>No fee statement found</div>
      </div>
    </div>

    
  </div>
</div>
</template>
<script>
import Navigation from "@/components/simi-auth/Navigation.vue";
import { executeJson, simitrack } from "@/api";
export default {
  name: "FeeStatement",
  components: { Navigation },
  data() { return { loading: true, items: [], search: '', showAdd: false, processing: false, addError: '', form: {studentId:''} }; },
  computed: {
    filteredItems() {
      if (!this.search) return this.items;
      var s = this.search.toLowerCase();
      return this.items.filter(function(item) { return JSON.stringify(item).toLowerCase().includes(s); });
    }
  },
  mounted() { this.loadData(); },
  methods: {
    fNum(v) { if (!v) return '0'; return Number(v).toLocaleString('en-KE'); },
    onSearch() {},
    viewItem(item) { console.log('View:', item); },
    async loadData() {
      this.loading = true;
      try {
        var r = await executeJson({ function: 'getStudentFeeStatement' }, simitrack);
        if (r.data.success) {
          var d = r.data.data;
          this.items = Array.isArray(d) ? d : (d.statement || d.data || []);
        }
      } catch (e) { console.error(e); }
      this.loading = false;
    },
    
  }
};
</script>
<style scoped>
.st-page{min-height:100vh;background:#0A1628;padding-top:70px;}
.st-topbar{position:fixed;top:0;left:0;right:0;z-index:100;background:rgba(10,22,40,.97);backdrop-filter:blur(20px);border-bottom:1px solid #1A3A6A;padding:10px 0;}
.st-topbar .container{display:flex;align-items:center;gap:12px;}
.st-back{color:#8BA4C4;font-size:22px;text-decoration:none;padding:4px;}
.st-back:hover{color:#4FC3F7;}
.st-page-title{color:#E8EDF4;font-size:18px;font-weight:700;margin:0;}
.st-card{background:#0F2347;border:1px solid #1A3A6A;border-radius:14px;padding:24px;margin-bottom:16px;}
.st-card-title{color:#E8EDF4;font-size:16px;font-weight:700;margin-bottom:16px;}
.st-stat-row{display:flex;flex-wrap:wrap;gap:12px;margin-bottom:20px;}
.st-stat{background:#0F2347;border:1px solid #1A3A6A;border-radius:12px;padding:16px 20px;flex:1;min-width:140px;cursor:pointer;transition:all .2s;}
.st-stat:hover{border-color:#2E86DE;transform:translateY(-2px);}
.st-stat-num{font-size:24px;font-weight:800;color:#4FC3F7;}
.st-stat-lbl{font-size:12px;color:#8BA4C4;margin-top:2px;}
.st-tabs{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:20px;}
.st-tab{background:#0F2347;border:1px solid #1A3A6A;color:#8BA4C4;border-radius:50px;padding:7px 16px;font-size:13px;font-weight:600;cursor:pointer;transition:all .2s;}
.st-tab.active,.st-tab:hover{background:rgba(46,134,222,.15);border-color:#2E86DE;color:#4FC3F7;}
.st-table{width:100%;border-collapse:collapse;}
.st-table th{color:#8BA4C4;font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:1px;padding:10px 12px;border-bottom:1px solid #1A3A6A;text-align:left;}
.st-table td{color:#E8EDF4;font-size:13px;padding:12px;border-bottom:1px solid #1A3A6A;}
.st-table tr:hover td{background:rgba(46,134,222,.05);}
.st-badge{padding:3px 10px;border-radius:50px;font-size:11px;font-weight:600;}
.st-badge-success{background:rgba(16,185,129,.15);color:#10B981;}
.st-badge-warning{background:rgba(245,158,11,.15);color:#F59E0B;}
.st-badge-danger{background:rgba(239,68,68,.15);color:#EF4444;}
.st-badge-info{background:rgba(46,134,222,.15);color:#4FC3F7;}
.st-btn{border:none;border-radius:8px;padding:8px 16px;font-size:13px;font-weight:600;cursor:pointer;transition:all .2s;}
.st-btn-sm{padding:5px 12px;font-size:12px;}
.st-btn-blue{background:rgba(46,134,222,.15);color:#4FC3F7;border:1px solid rgba(46,134,222,.3);}
.st-btn-blue:hover{background:rgba(46,134,222,.25);}
.st-btn-green{background:rgba(16,185,129,.15);color:#10B981;border:1px solid rgba(16,185,129,.3);}
.st-btn-red{background:rgba(239,68,68,.15);color:#EF4444;border:1px solid rgba(239,68,68,.3);}
.st-empty{text-align:center;padding:40px 20px;color:#8BA4C4;}
.st-empty i{font-size:48px;color:#1A3A6A;display:block;margin-bottom:12px;}
.st-modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:200;display:flex;align-items:center;justify-content:center;padding:20px;}
.st-modal{background:#0F2347;border:1px solid #1A3A6A;border-radius:16px;padding:28px;width:100%;max-width:500px;max-height:90vh;overflow-y:auto;}
.st-modal-title{color:#E8EDF4;font-size:18px;font-weight:700;margin-bottom:20px;display:flex;align-items:center;justify-content:space-between;}
.st-modal-close{color:#8BA4C4;cursor:pointer;font-size:22px;background:none;border:none;}
.st-label{color:#8BA4C4;font-size:13px;font-weight:600;margin-bottom:6px;display:block;}
.st-input,.st-select,.st-textarea{width:100%;background:#0A1628;border:1px solid #1A3A6A;border-radius:10px;padding:10px 14px;color:#E8EDF4;font-size:14px;outline:none;transition:border .2s;}
.st-input:focus,.st-select:focus,.st-textarea:focus{border-color:#2E86DE;}
.st-textarea{min-height:80px;resize:vertical;}
.st-search{background:#0A1628;border:1px solid #1A3A6A;border-radius:10px;padding:9px 14px 9px 36px;color:#E8EDF4;font-size:14px;outline:none;width:100%;max-width:300px;}
.st-search-wrap{position:relative;}.st-search-wrap i{position:absolute;left:12px;top:50%;transform:translateY(-50%);color:#8BA4C4;}
.st-spinner{display:flex;justify-content:center;padding:40px;}.st-spinner .spinner-border{color:#2E86DE;}
@media(max-width:768px){.st-stat-row{flex-direction:column;}.st-stat{min-width:100%;}}
.st-alert{padding:10px 14px;border-radius:10px;font-size:13px;margin-bottom:16px;}
.st-alert-danger{background:rgba(255,107,107,.1);border:1px solid rgba(255,107,107,.2);color:#FF9999;}
</style>